import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import OwlCarousels from './owl-carousel';
import { brandSlider } from '../settings';

import { connect } from 'react-redux';
import { getAllBrands } from '../../actions/brandActions';

import './brandstyle.css';

function Brand( props ) {
    
    const { adClass = "mt-5 mb-5 owl-simple", count = 7, start = 0, sliderOption = brandSlider } = props;

    let brands = props.brands;   

    return (
        <OwlCarousels adClass={ `${adClass} d-flex brand-carousel cols-xl-7 cols-lg-5 cols-md-4 cols-sm-3 cols-2 marquesCarossel` } carouselOptions={ sliderOption } carouselId="brandslider">
            { brands.map( ( item, i ) => {
                return (
                    <Link to={ `${process.env.REACT_APP_PUBLIC_URL}/shop/bybrand/${item.slug}` } className="brand" key={ i } >



                        { item.fileName ?
                            <img className="bg-white marqueImg" src={ `${process.env.REACT_APP_API_URL}/uploads/brands/` + item.fileName } alt={ item.nameFr } />
                            :                             <img className="bg-white marqueImg" src='https://cdn-icons-png.flaticon.com/512/180/180758.png' alt={ item.nameFr } />

                        }
                        
                    </Link>
                )
            } )
            }
        </OwlCarousels>
    )
}

const mapStateToProps = (state) => {
    return {
        brands: state.brands.brands ? state.brands.brands : [],
    }
}

export default  connect(mapStateToProps, { getAllBrands } ) (Brand);